import { apiMutator } from "./http/mutator";

export type NotificationSettingsChannel = "Sms" | "Email";

export interface UpdateNotificationSettingsRequest {
  dailyTextNotificationsEnabled: boolean;
  email?: string;
  preferredDailyChannel?: NotificationSettingsChannel;
  preferredSendTime?: string;
  timezone?: string;
}

export function putApiNotificationSettings(data: UpdateNotificationSettingsRequest) {
  return apiMutator<void>({
    url: "/api/notification-settings",
    method: "PUT",
    data,
  });
}
